"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const vd_customer_ui_core_react_1 = require("@grupoboticario/vd-customer-ui-core-react");
const react_1 = require("react");
const customer_1 = require("../../../../utils/helpers/customer");
const constants_1 = require("../../../constants");
const utils_1 = require("../../../utils");
const CustomerProvider = ({ catalogSlug, children }) => {
    const [contextState, setState] = (0, react_1.useState)({
        isLogged: false,
        isRecognized: false,
        customerId: undefined,
        customerInfo: undefined,
    });
    const redirectToCatalog = (catalogSlug) => {
        window.location.href = `/${catalogSlug}`;
    };
    const handleLogout = (0, react_1.useCallback)(() => {
        (0, vd_customer_ui_core_react_1.removeCustomerAuthToken)();
        setState({
            isRecognized: (0, customer_1.isCustomerIdentified)(),
            isLogged: (0, utils_1.isConsumerLogged)(),
            customerId: undefined,
            customerInfo: undefined,
        });
        redirectToCatalog(catalogSlug);
    }, [catalogSlug]);
    const loadRecognitionState = () => {
        setState({
            isLogged: (0, utils_1.isConsumerLogged)(),
            isRecognized: (0, customer_1.isCustomerIdentified)(),
            customerId: (0, customer_1.getCustomerId)(),
            customerInfo: (0, customer_1.getCustomerInfoFromJwt)(),
        });
    };
    const contextValue = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, contextState), { handleLogout })), [handleLogout, contextState]);
    (0, react_1.useEffect)(() => {
        loadRecognitionState();
        document.addEventListener(constants_1.customEvents.customerTokenUpdated, loadRecognitionState);
        window.addEventListener(vd_customer_ui_core_react_1.EventCustomerRecognitionChange, loadRecognitionState);
        return () => {
            document.removeEventListener(constants_1.customEvents.customerTokenUpdated, loadRecognitionState);
            window.removeEventListener(vd_customer_ui_core_react_1.EventCustomerRecognitionChange, loadRecognitionState);
        };
    }, []);
    return (0, jsx_runtime_1.jsx)(utils_1.CustomerContext.Provider, Object.assign({ value: contextValue }, { children: children }));
};
exports.CustomerProvider = CustomerProvider;
